export default "__VITE_ASSET__CaNwFO$s__"